module.exports = __webpack_public_path__ + "static/media/realtors-icon-13.f49964b3.svg";